import {
  toWSDateString,
  useWSModal,
  WSElement,
  WSMessageBox,
  WSText
} from "@wingspanhq/fe-component-library";
import { getCurrentTaxPaymentQuarter } from "@wingspanhq/utils/dist/date/taxDeadlines";
import React from "react";
import { formatInternalDeadline } from "../utils";

export const ModalQuarterInfo: React.FC = () => {
  const quarterInfo = getCurrentTaxPaymentQuarter();

  const formattedInternalDeadline = formatInternalDeadline(
    quarterInfo.internalDeadline
  );

  const formattedIrsDeadline = toWSDateString(
    quarterInfo.irsDeadline,
    "monthDayYear"
  );

  return (
    <WSElement>
      <WSText.ParagraphSm mb="M">
        To ensure timely processing and avoid penalties, please submit your
        quarterly estimated tax payments by <b>{formattedInternalDeadline}</b>,
        which is 4 business days before the IRS due date of{" "}
        <b>{formattedIrsDeadline}</b>.
      </WSText.ParagraphSm>
      <WSMessageBox.Info noBorder>
        <WSText.Heading5 mb="M">Important:</WSText.Heading5>
        <WSText.ParagraphSm mb="M" color="gray600">
          If your payment request is submitted after our processing deadline of{" "}
          <b>{formattedInternalDeadline}</b>, we cannot guarantee it will be
          processed by the IRS due date of <b>{formattedIrsDeadline}</b>. Late
          payments may be applied to the next quarter, and penalties from the
          IRS may apply.
        </WSText.ParagraphSm>
      </WSMessageBox.Info>

      <WSText.ParagraphSm mt="XL" color="gray500">
        TIP: If you're tempted to withdraw for non-emergencies, we recommend
        making regular payments to the IRS.
      </WSText.ParagraphSm>
    </WSElement>
  );
};

export const useModalQuarterInfo = () =>
  useWSModal(ModalQuarterInfo, {
    title: "When should I send my quarterly estimate payment to the IRS?",
    size: "M"
  });
